export const authKeys = {
  all: ['auth'],
  myProfile: () => [...authKeys.all, 'myProfile']
} as const;
